// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"32a7455f","558":"8c9eb944"}[chunkId] + ".chunk.js";
};